import * as types from '../actions/types';

const initialState = {
  isError: false,
  isRefresh: false
};

const showNewChatDesignReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_SHOW_NEW_CHAT_DESIGN_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.CHANGE_SHOW_NEW_CHAT_DESIGN_SUCCEDDED:
      return {
        ...state,
        error: null
      };
    case types.CHANGE_SHOW_NEW_CHAT_DESIGN_FAILED:
      return {
        ...state,
        isError: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default showNewChatDesignReducer;
